import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import {
  TableBody,
  TableRow,
  TableCell,
} from '@mui/material';
import useTable from '../../../components/useTable';
import SendIntakeModal from '../../SendIntakeModal';
import { Controls } from '../../../components/controls/Controls';

const header = [
  { id: 'patientId', label: 'Patient ID' },
  { id: 'firstName', label: 'First Name' },
  { id: 'lastName', label: 'Last Name' },
  { id: 'healthCardNumber', label: 'Health Card Number' },
  { id: 'birthDate', label: 'Birth Date' },
  { id: 'gender', label: 'Gender' },
  { id: 'phoneNumber', label: 'Phone Number' },
];

export default function AccuroPatientTable(props) {
  const {
    patients, setSuccessMessage, setErrorMessage,
  } = props;

  const [modalVisible, setModalVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [selectedPhoneNumber, setSelectedPhoneNumber] = useState('');

  const visibleHeader = useMemo(() => header, []);

  const {
    TblContainer,
    TblHead,
    currentPageDataSorted,
  } = useTable(patients, visibleHeader, { fn: (items) => items });

  useEffect(() => {
  }, [patients]);

  const handleOpenModal = (patient, phoneNumber) => {
    setSelectedPatient(patient);
    setSelectedPhoneNumber(phoneNumber);
    setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setSelectedPatient(null);
    setSelectedPhoneNumber('');
  };

  return (
    <>
      <TblContainer>
        <TblHead />
        <TableBody>
          {patients && currentPageDataSorted().map((patient) => (
            <TableRow
              key={patient.patientId}
            >
              <TableCell>{patient.patientId}</TableCell>
              <TableCell>{patient.demographics.firstName}</TableCell>
              <TableCell>{patient.demographics.lastName}</TableCell>
              <TableCell>{patient.demographics.healthCard.phn}</TableCell>
              <TableCell>{patient.demographics.birthday}</TableCell>
              <TableCell>{patient.demographics.genderId === 1 ? 'Male' : 'Female'}</TableCell>
              {patient.demographics.phones && patient.demographics.phones.map((item) => (
                <TableCell key={item.number}>
                  <Controls.Button
                    sx={{ margin: '10px 0', padding: '10px' }}
                    onClick={() => handleOpenModal(patient, item.number)}
                    text={`${item.contactType}: ${item.number}`}
                    data-testid="newPatientIntakeButton"
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </TblContainer>
      {modalVisible && selectedPatient && (
        <SendIntakeModal
          modalVisible={modalVisible}
          handleClose={handleCloseModal}
          value={selectedPhoneNumber}
          patient={selectedPatient}
          setSuccessMessage={setSuccessMessage}
          setErrorMessage={setErrorMessage}
          integrationType="accuro"
          showAppointmentField={false}
        />
      )}
    </>
  );
}

AccuroPatientTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  patients: PropTypes.arrayOf(PropTypes.object).isRequired,
  setSuccessMessage: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
};
